/** @format */

import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import FormControl from "./FormControl";
import Button from "../component/Button";
import * as Yup from "yup";
import { MdCancel } from "react-icons/md";
import { FaSpinner } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import useStorage from "../hooks/useStorage";
import { db, doc, setDoc } from "../firebase/utils";

function StudentUpdateForm({ createForm, setCreateForm }) {
  //WE DESTRUCTURE THE CURRENT USER I.E CURRENTLY LOGGED IN USER & PROFILE PIC DATA "profilePic" WHICH WILL BE PASSED AS AN ARGUEMENT TO THE USE STORAGE HOOK... FROM USEAUTH
  const { currentUser, profilePic } = useAuth();

  //CUSTOM HOOK FOR UPLOADING FILE
  const { url, err, setUrl } = useStorage(profilePic);

  //DropDown Menu for "SELECT INPUT"
  const selectClass = [
    {
      key: "Select Class",
      value: "",
    },
    {
      key: "JSS 1",
      value: "JSS 1",
    },
    { key: "JSS 2", value: "JSS 2" },
    { key: "JSS 3", value: "JSS 3" },
    { key: "SS 1", value: "SS 1" },
    { key: "SS 2", value: "SS 2" },
    { key: "SS 3", value: "SS 3" },
  ];

  //INITIAL VALUES FOR FORMIK LIB
  const initialValues = {
    firstName: "",
    lastName: "",
    otherName: "",
    email: "",
    age: "",
    selectClass: "",
    profileImage: null,
  };

  const validationSchema = Yup.object({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    email: Yup.string().email().required("Required"),
    age: Yup.string().required("Required"),
    selectClass: Yup.mixed().required("Required"),
  });

  // DATABASE LOGIC

  const onSubmit = (values, onSubmitProps) => {
    const { resetForm } = onSubmitProps;
    const { otherName, firstName, lastName, email, age, selectClass } = values;
    const name = `${firstName} ${lastName}`;

    //CREATE A DOCUMENT REFERENCE AND 'STUDENTS' SUBCOLLECTION UNDER USER.ID DOC
    const docRef = doc(db, "users", currentUser?.uid, "students", name);
    // console.log(docRef);

    setDoc(docRef, {
      firstName,
      lastName,
      otherName,
      email,
      age,
      selectClass,
      url,
      id: name, //ID to update and delete student record
    });
    resetForm();
    setCreateForm(false);
    setUrl(null);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => {
        return (
          <Form className="form">
            <div className="form__title--container">
              <h2 className={`form__title`}>Student Update Form</h2>
              <MdCancel
                onClick={() => setCreateForm(false)}
                style={{ color: "rgb(202,8,8)", fontSize: "1.2rem" }}
              />
            </div>
            <hr />
            <FormControl
              control="input"
              name="firstName"
              label="First Name"
              placeholder="kindly input student's first name"
              type="text"
              required
            />
            <FormControl
              control="input"
              name="lastName"
              label="Last Name"
              placeholder="kindly input student's last name"
              type="text"
              required
            />
            <FormControl
              control="input"
              name="otherName"
              label="Other Name"
              placeholder="kindly input student's Other/Middle name"
              type="text"
            />

            <FormControl
              control="input"
              name="email"
              label="Email"
              placeholder="please enter email"
              type="text"
              required
            />

            <FormControl
              control="input"
              name="age"
              label="Date of Birth"
              type="date"
              required
            />

            <FormControl
              control="select"
              name="selectClass"
              label="Select Class"
              type="select"
              options={selectClass}
              required
            />

            <FormControl
              control="file"
              name="profileImage"
              type="file"
              label="kindly upload a profile picture of your child/ward"
              required
            />

            <div className="submit__button">
              <Button
                btnText={
                  formik.isSubmitting ? (
                    <FaSpinner className="spinner"></FaSpinner>
                  ) : (
                    "Submit"
                  )
                }
                color="#fff"
                type="submit"
                bg="var(--success)"
                btnBlock
                disabled={!formik.isValid || formik.isSubmitting || !url}
              />
              {!formik.isValid && (
                <small
                  style={{
                    color: "red",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  kindly fill all required fields...
                </small>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default StudentUpdateForm;
